<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t($route.name))"
      icon="mdi-bookmark-outline"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="$t(type)"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
          
        </v-list>
      </v-menu>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        v-model="selected"
        v-column-resize="reservedItemsColumnPlugins"
        v-column-drag="reservedItemsColumnPlugins"
        v-column-pin="reservedItemsColumnPlugins"
        :headers="tableHeaders"
        :items="items"
        :page.sync="page"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                class="pl-action-cell__btn" icon x-small
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
                        <v-list dense>
              <v-list-item
                v-if="!item.head.lock"
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                link
                @click="print(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + type +'/edit/' + item.head.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row"><a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a></span>
          </div>
        </template>
        <template v-slot:item.price.price="{ item }">
          {{ $numberFormat((item.price ? item.price.price : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.head.doc_header.number="{ item }">
          <a
            v-if="item.head.doc_header"
            @click="openComponent('accountingPrint', item.head.doc_head_id)"
          >
            {{ item.head.doc_header.number }}
          </a>
        </template>
        <template v-slot:item.head.customer.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.head.customer_id)"
            >
              {{ item.head.customer.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.head.customer.fin_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('turnover') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.product.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('product', item.product_id)"
            >
              {{ item.product.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('productTurnover', item.product_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('productTurnover') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.pre_invoice="{ item }">
          <v-icon
            v-if="item.pre_invoice == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
        </template>
        <template v-slot:item.count="{ item }">
          {{ $numberFormat((item.count ? item.count : 0)) }}
        </template>
        <template v-slot:item.fee="{ item }">
          {{ $numberFormat((item.fee ? item.fee : 0)) }}
          <v-chip small>
            {{item.head.currency.name}}
          </v-chip>
        </template>
        <template v-slot:item.tax="{ item }">
          {{ $numberFormat((item.tax ? item.tax : 0)) }}
        </template>
        <template v-slot:item.discount="{ item }">
          {{ $numberFormat((item.discount ? item.discount : 0)) }}
        </template>
        <template v-slot:item.sumCurrency="{ item }">
          {{ $numberFormat(item.sumCurrency) }}
          <v-chip small>
            {{item.head.currency.name}}
          </v-chip>
        </template>
        <template v-slot:item.sum="{ item }">
          {{ $numberFormat((item.sumMainCurrency ? item.sumMainCurrency : 0)) }}
        </template>
        <template v-slot:item.cost="{ item }">
          {{ $numberFormat((item.cost ? item.cost : 0), 'currency', $store.state.currency.decimal) }}
        </template>
        <template v-slot:item.content="{ item }">
          {{item.content}}
        </template>
        <template v-slot:item.dkpc="{ item }">
          {{(item.productIntegrator && item.productIntegrator.digikalaVariantId ? item.productIntegrator.digikalaVariantId : '')}}
        </template>
        <template v-slot:item.woocommerce="{ item }">
          {{(item.productIntegrator && (item.productIntegrator.woocommerceVariantId || item.productIntegrator.woocommerceId) ? (item.productIntegrator.woocommerceId ? item.productIntegrator.woocommerceId  + ' - ' : '') + ' ' + item.productIntegrator.woocommerceVariantId : '')}}
        </template>
        <template v-slot:item.profit="{ item }">
          {{ $numberFormat((item.profit ? item.profit : 0), 'currency', item.head.currency.decimal) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.number="{ item }">
          <a @click="edit(item)">
            {{ item.number }}
          </a>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="(item.head && item.head.tags) || []" />
        </template>
        <template
          v-slot:body.append
        >
          <tr
            v-if="isMobile || mobileShow"
            :class="{'v-data-table__mobile-table-row':isMobile}"
          >
            <td
              :colspan="`${isMobile?6:Number(showHeaders.length) - (type != 'purchase' && type != 'returnSell' ? 10 : 11)}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('count') + ':' : '') }} {{ $numberFormat(totals.count) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('remittedCount') + ':' : '') }} {{ $numberFormat(totals.sumRemittedCount, 3) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('reservedCount') + ':' : '') }} {{ $numberFormat(totals.sumReservedCount, 3) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('fee') + ':' : '') }} {{ $numberFormat(totals.fee) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('discount') + ':' : '') }} {{ $numberFormat(totals.discount, 'currency', $store.state.currency.decimal) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('tax') +':': '') }}  {{ $numberFormat(totals.tax, 'currency', $store.state.currency.decimal) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('sum') +':': '') }} {{ $numberFormat(totals.sumCurrency) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('sum') +':': '') }} {{ $numberFormat(totals.sum, 'currency', $store.state.currency.decimal) }}
            </td>
            <td
              v-if="type != 'purchase' && type != 'returnSell'"
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('cost') +':': '') }}  {{ $numberFormat(totals.cost, 'currency', $store.state.currency.decimal) }}
            </td>
            <td
              v-if="type != 'purchase' && type != 'returnSell'"
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('profit') +':': '') }} {{ $numberFormat(totals.profit, 'currency', $store.state.currency.decimal) }}
            </td>
            <td
              :colspan="`${isMobile?6:5}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t('sumInPage') }}</span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('count') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.count) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('remittedCount') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sumRemittedCount, 3) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('reservedCount') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sumReservedCount, 3) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('fee') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.fee) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('discount') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.discount, 'currency', $store.state.currency.decimal) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('tax') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.tax, 'currency', $store.state.currency.decimal) }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t('sum') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sumCurrency) }}
              </span>
            </span>
            <span
              v-if="type != 'purchase' && type != 'returnSell'"
              class="app-list-page-totals__item"
            >
              <span class="app-list-page-totals__key">{{ $t('cost') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.cost, 'currency', $store.state.currency.decimal) }}
              </span>
            </span>
            <span
              v-if="type != 'purchase' && type != 'returnSell'"
              class="app-list-page-totals__item"
            >
              <span class="app-list-page-totals__key">{{ $t('profit') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.profit, 'currency', $store.state.currency.decimal) }}
              </span>
            </span>
            <span
              class="app-list-page-totals__item app-list-page-totals__item--final"
            >
              <span class="app-list-page-totals__key">{{ $t('sum') }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sum, 'currency', $store.state.currency.decimal) }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t($route.name))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="$t(type)"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="invoicePrintDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="invoicePrintDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint
            :id-prop="printId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
      :draggable="true"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="account"
              :title="$t('customer')"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="product"
              type="product"
              :title="$t('product')"
              :outlined="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="currencyFilter"
              :title="$t('currency')"
              type="currency"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="fromAmount"
              :dense="true"
              :label="$t('from') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="toAmount"
              :dense="true"
              :label="$t('until') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="group"
              :title="$t('main-group')"
              type="productGroup"
              :data="JSON.stringify({parent:null,type:'group'})"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat1"
              :title="$t('other-group')"
              type="productGroup"
              :data="JSON.stringify({parent:null,type:'category'})"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat2"
              title="category"
              type="productGroup"
              :data="JSON.stringify({parent:null,type:'subcategory'})"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="entrepot"
              title="entrepot"
              type="entrepot"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="accountCategory"
              :title="$t('accountCategory')"
              type="accountCategory"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <v-select
              v-model="reserveCount"
              :label="$t('reservedCount')"
              :items="reserveCountOption"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="label"
            />
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import Invoicprint from './print'
  import General from '../../../../Mixins/general'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'invoiceItemList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Invoicprint,
      Print,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      excelItems: [],
      selected: [],
      invoicePrintDialog: false,
      printDialog: false,
      deletDialog: false,
      registerar: null,
      accountCategory: null,
      entrepot: null,
      cat2: null,
      cat1: null,
      group: null,
      dialogData: null,
      product: null,
      account: null,
      currencyFilter: null,
      fromAmount: null,
      toAmount: null,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      printId: null,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      reservedItems: 'active',
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      pageCount: 1,
      page: 1,
      reserveCount: null
    }),
    computed: {
      proListKey () {
        return this.reservedItemsColumnPersistKey
      },
      proListLocked () {
        return this.reservedItemsLockedColumns
      },
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      reservedItemsColumnPersistKey () {
        // Fixed key: this list has a single route and a fixed type.
        return 'invoice-reserved-items-list-columns'
      },
      reservedItemsLockedColumns () {
        // Fixed sticky block: select + actions + row + id + number (no unpin/drag)
        var locked = ['actions', 'head.id', 'head.number']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      reservedItemsColumnPlugins () {
        // show-select inserts a leading checkbox <th>; pad visibleHeaders so
        // pin/resize/drag index mapping stays aligned with thead cells.
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.reservedItemsLockedColumns,
          anchor: 'head.number',
          minWidth: 60,
          persistKey: this.reservedItemsColumnPersistKey,
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type === 'purchase' || app.type === 'returnSell') {
            if (s.value === 'cost' || s.value === 'profit') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        const totals = this.items.reduce((acc, d) => {
          acc.count += parseFloat(d.count)
          acc.fee += parseFloat(d.fee)
          acc.discount += parseFloat(d.discount)
          acc.tax += parseFloat(d.tax)
          acc.sumCurrency += parseFloat(d.sumCurrency)
          acc.sum += parseFloat(d.sumMainCurrency)
          acc.cost += parseFloat(d.cost)
          acc.profit += parseFloat(d.profit)
          acc.sumRemittedCount += parseFloat(d.entrepotCount)
          acc.sumReservedCount += parseFloat(d.reservedCount)
          return acc
        }, {
          count: 0,
          fee: 0,
          discount: 0,
          tax: 0,
          sumCurrency: 0,
          sum: 0,
          cost: 0,
          profit: 0,
          sumRemittedCount: 0,
          sumReservedCount: 0
        })
        return totals
      },
      reserveCountOption () {
        return [
          { label: this.$t('have'), value: true },
          { label: this.$t('haveNot'), value: false }
        ]
      }
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      // this.getItems()
    },
    beforeMount () {
      this.type = 'sell'
      this.headers = [
        {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'head.id',
          table: 'invoice_header.id',
          width: 100,
        },
        {
          text: this.$t('number'),
          sortable: true,
          value: 'head.number',
          table: 'invoice_header.number',
          width: 100,
        },
        {
          text: this.$t('number') + ' ' + this.$t('document'),
          sortable: true,
          value: 'head.doc_header.number',
          table: 'doc_header.number',
          width: 70,
        },
        {
          text: this.$t('customer-name'),
          sortable: false,
          value: 'head.customer.name',
          width: 200,
        },
        {
          text: this.$t('date'),
          sortable: false,
          value: 'head.date',
          width: 80,
        },
        {
          text: this.$t('product'),
          sortable: false,
          value: 'product.name',
          width: 200,
        },
        {
          text: this.$t('unit'),
          sortable: false,
          value: 'product.unit.fame',
          width: 100,
        },
        {
          text: this.$t('invoiceCount'),
          sortable: true,
          value: 'count',
          table: 'invoice_articles.count',
          width: 100,
        },
        {
          text: this.$t('remittedCount'),
          sortable: false,
          value: 'entrepotCount',
          width: 70,
        },
        {
          text: this.$t('reservedCount'),
          sortable: true,
          value: 'reservedCount',
          table: 'reservedCount',
          width: 70,
        },
        {
          text: this.$t('fee'),
          sortable: true,
          value: 'fee',
          table: 'invoice_articles.fee',
          width: 100,
        },
        {
          text: this.$t('discount'),
          sortable: true,
          value: 'discount',
          table: 'invoice_articles.discount',
          width: 100,
        },
        {
          text: this.$t('tax'),
          sortable: true,
          value: 'tax',
          table: 'invoice_articles.tax',
          width: 100,
        },
        {
          text: this.$t('sum') + '(' + this.$t('currency') + ')',
          sortable: false,
          value: 'sumCurrency',
          width: 100,
        },
        {
          text: this.$t('sum') + ' (' + this.$store.state.currency.name + ')',
          sortable: false,
          value: 'sum',
          width: 100,
        },
        {
          text: this.$t('cost') + ' (' + this.$store.state.currency.name + ')',
          sortable: false,
          value: 'cost',
          width: 100,
        },
        {
          text: this.$t('profit') + ' (' + this.$store.state.currency.name + ')',
          sortable: false,
          value: 'profit',
          width: 100,
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
          width: 100,
        },
      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      reorderPinnedHeaders(this.headers, {
        locked: this.reservedItemsLockedColumns,
        anchor: 'head.number',
      })
      this.loadReservedItemsColumnSettings()
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    mounted () {
      this.getItems()
    },
    methods: {
      loadReservedItemsColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.reservedItemsColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.reservedItemsLockedColumns,
            anchor: 'head.number',
          })
          app.$forceUpdate()
        })
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: this.type + 'Edit', params: { id: item.head.uid } })
      },
      print (item) {
        this.printId = item.head.uid
        this.invoicePrintDialog = true
      },
      getItems () {
        var app = this
        app.loading = true
        app.filter = false
        app.$axios.get(this.$endpoint + 'invoiceReport', {
          params: {
            reservedItems: app.reservedItems,
            select: 'itemsReserved',
            search: app.search,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            accountCategory: app.accountCategory,
            entrepot: app.entrepot,
            branch: app.branch,
            product: app.product,
            account: app.account,
            fromDate: app.fromDate,
            toDate: app.toDate,
            fromAmount: app.fromAmount,
            registerar: app.registerar,
            toAmount: app.toAmount,
            fromNumber: app.fromNumber,
            toNumber: app.toNumber,
            currency: app.currencyFilter,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
            reserve_count: app.reserveCount
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            type: app.$t(d.head.type),
            id: d.head.id,
            number: d.head.number,
            customer: (d.head && d.head.customer ? d.head.customer.name : 0),
            product: (d.product ? d.product.name : 0),
            unit: (d.product && d.product.unit ? d.product.unit.name : 0),
            date: (d.head ? d.head.date : 0),
            currency: (d.head && d.head.currency ? d.head.currency.name : 0),
            count: app.$numberFormat((d.count ? d.count : 0)),
            fee: app.$numberFormat((d.fee ? d.fee : 0)),
            discount: app.$numberFormat(d.discount),
            tax: app.$numberFormat(d.tax),
            cost: app.$numberFormat(d.cost),
            profit: app.$numberFormat(d.profit),
            content: d.content,
            remittedCount: d.entrepotCount ? d.entrepotCount : 0,
            reservedCount: d.reservedCount ? d.reservedCount : 0,
            dkpc: (d.productIntegrator ? d.productIntegrator.digikalaVariantId : null),
            woocommerceId: (d.productIntegrator ? d.productIntegrator.woocommerceId : null),
            woocommerceVariantId: (d.productIntegrator ? d.productIntegrator.woocommerceVariantId : null),
            user: (d.user ? d.user.name : ''),
          })
        })
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
